module.exports = __webpack_public_path__ + "static/media/icb-logo-02.66848f44.png";